import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f9807e16"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-lg container-fluid my_innovation" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "My Innovations", -1))
const _hoisted_3 = { class: "card card-body border-0 shadow" }
const _hoisted_4 = { class: "p-input-icon-left mb-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_6 = { class: "p-text-center" }
const _hoisted_7 = { class: "p-text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("section", _hoisted_3, [
      _createVNode(_component_DataTable, {
        responsiveLayout: "scroll",
        breakpoint: "700px",
        value: _ctx.getMyInnovations,
        paginator: true,
        loading: _ctx.loading,
        rows: 10,
        selectionMode: "single",
        columnResizeMode: "fit",
        scrollHeight: "flex",
        globalFilterFields: ['innovation'],
        filters: _ctx.filters,
        "onUpdate:filters": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters) = $event)),
        filterDisplay: "menu",
        class: "p-datatable-sm",
        "row-hover": true,
        onRowClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toPartners($event)))
      }, {
        header: _withCtx(() => [
          _createElementVNode("span", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_InputText, {
              modelValue: _ctx.filters['global'].value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters['global'].value) = $event)),
              placeholder: "Keyword Search ...",
              class: "p-inputtext-sm w-100"
            }, null, 8, ["modelValue"])
          ])
        ]),
        empty: _withCtx(() => [
          _createElementVNode("h6", _hoisted_6, "No " + _toDisplayString(_ctx.title) + " found.", 1)
        ]),
        loading: _withCtx(() => [
          _createElementVNode("h6", _hoisted_7, "Loading " + _toDisplayString(_ctx.title) + " data. Please wait.", 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            header: "#",
            headerStyle: "width:2rem"
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "innovation",
            header: "Innovations",
            sortable: true,
            style: {"min-width":"10rem"},
            frozen: true
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data?.solution_title), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "status",
            header: "Status",
            style: {"min-width":"10rem"}
          }),
          _createVNode(_component_Column, {
            style: {"min-width":"12rem"},
            field: "partnership_interest",
            header: "Partnership Interest"
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.interests?.length || 0), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            style: {"min-width":"12rem"},
            field: "confirmed_partnership",
            header: "Confirmed Partnership"
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.partnerships?.length), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value", "loading", "filters"])
    ])
  ]))
}